module.exports = __webpack_public_path__ + "img/view_structure.92ed6cdc.svg";